<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <circle cy="6.5" cx="9.5" r="1.5"></circle>
    <circle cy="6.5" cx="14.5" r="1.5"></circle>
    <circle cy="12.5" cx="9.5" r="1.5"></circle>
    <circle cy="12.5" cx="14.5" r="1.5"></circle>
    <circle cy="18.5" cx="9.5" r="1.5"></circle>
    <circle cy="18.5" cx="14.5" r="1.5"></circle>
  </svg>
</template>

<script>
export default {
  name: "drug-n-drop-vertical-anchor"
};
</script>

<style scoped></style>
